import { Flex, VStack, StackSeparator } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { CraNodeDetail } from "./node/CraNodeDetail";
import { CraWayDetail } from "./cra-way/CraWayDetail";
import { SurveyDetail } from "./survey/SurveyDetail";
import { useStores } from "../../../../shared/stores/RootStore";
import useAutoResizeMap from "../../../../hooks/useAutoResizeMap";
import { LifeCycleStage } from "../../../../cra/models/LifeCycleStage";
import { HlaWayDetail } from "../../../../hla/views/HlaWayDetail/HlaWayDetail";
import { MapQueryControls } from "../hla-query/ImportHlaControls";
import { useEffect } from "react";
import { MapPageView } from "../../../../survey/stores/MapStore";
import { SimulationWayDetail } from "../../../../hla/views/HlaSimulation/SimulationWayDetail";
import { HlaSimulationComparisonView } from "../../../../hla/views/HlaSimulationComparisonView";

const DetailBarBase: React.FC = () => {
  useAutoResizeMap();

  const {
    craNodeStore,
    craWayStore,
    hlaStore,
    mapQueryStore,
    simulationStore,
    mapStore,
    surveyStore,
  } = useStores();

  const selectedCraWay = craWayStore.getSelected();
  const hlaWay = hlaStore.getSelected();
  const distanceUnit = surveyStore.distanceUnit;

  useEffect(() => {
    if (!hlaWay?.id) {
      simulationStore.clearSelectedSimulation();
      return;
    }
    if (!hlaWay.verified) {
      simulationStore.clearSelectedSimulation();
      return;
    }
    simulationStore.getSimulaions(hlaWay.id).then((data) => {
      if (data?.simulationWay?.verified) {
        simulationStore.finishSimulation();
      } else if (data?.simulationWay) {
        simulationStore.editSimulation();
      } else {
        simulationStore.clearSelectedSimulation();
      }
    });
    // eslint-disable-next-line
  }, [hlaWay?.id]);

  if (mapQueryStore.active) {
    return <MapQueryControls />;
  }

  if (craNodeStore.getSelected()) {
    return (
      <Flex
        flexShrink={0}
        flexDirection="column"
        w={selectedCraWay?.lifeCycleStage === LifeCycleStage.Review ? 540 : 320}
      >
        <CraNodeDetail />
      </Flex>
    );
  }

  if (selectedCraWay) {
    return (
      <Flex
        flexShrink={0}
        flexDirection="column"
        w={selectedCraWay.lifeCycleStage === LifeCycleStage.Review ? 540 : 320}
      >
        <CraWayDetail />
      </Flex>
    );
  }

  if (hlaWay) {
    if (!hlaWay.verified) {
      mapStore.setView(MapPageView.Map);
      return (
        <VStack minW="50%" maxW="50%" separator={<StackSeparator />}>
          <HlaWayDetail />
        </VStack>
      );
    } else {
      if (simulationStore.isEditing && simulationStore.selectedSimulationWay) {
        mapStore.setView(MapPageView.Map);
        return (
          <VStack minW="50%" maxW="50%" separator={<StackSeparator />}>
            <SimulationWayDetail />
          </VStack>
        );
      }

      if (
        simulationStore.isSimulationOpen &&
        simulationStore.selectedSimulationWay
      ) {
        mapStore.setView(MapPageView.SimulationsCompare);
        return (
          <VStack width="100%" separator={<StackSeparator />}>
            <HlaSimulationComparisonView distanceUnit={distanceUnit} />
          </VStack>
        );
      }
    }

    return (
      <VStack width="50%" separator={<StackSeparator />}>
        <HlaWayDetail />
      </VStack>
    );
  }

  return (
    <Flex flexShrink={0} flexDirection="column" w={320}>
      <SurveyDetail />
    </Flex>
  );
};

export const DetailBar = observer(DetailBarBase);
